
import React from 'react';

export default function DataTableActionButton( {icon, title, onClick, className, ...props} ){
  return (<>
    <button className={`clickable btn shadow-sm btn-circle ${className}`} title={title} onClick={onClick}>{icon ? icon : title}</button>
  </>);
}
